import Link from 'next/link';

import { Typography } from 'lighthouse';

import { ShelfHeaderProps } from './models';

import { ArrowLeft } from 'iconsax-react';

export const ShelfHeader = ({ badge, title, subtitle, href, linkLabel, dark = false }: ShelfHeaderProps) => (
    <div className='relative mb-6 flex flex-wrap items-end justify-between gap-x-6 gap-y-2 md:mb-8'>
        <div className='min-w-0 max-w-2xl'>
            <span
                className={`mb-3 inline-flex items-center gap-2 rounded-full px-3 py-1 ${
                    dark ? 'border border-solid border-sky-300/30 bg-sky-300/10 text-sky-200' : 'bg-primary/10 text-primary'
                }`}>
                <span aria-hidden className='h-1.5 w-1.5 rounded-full bg-brandYellow' />
                <Typography variant='caption' component='span' className='font-bold leading-5 text-current'>
                    {badge}
                </Typography>
            </span>
            <Typography
                variant='h5'
                component='h2'
                color={dark ? 'whiteHighEmphasis' : 'blackHighEmphasis'}
                className={`!m-0 font-extrabold leading-[1.6] md:text-3xl md:leading-[1.6] ${dark ? 'text-white' : ''}`}>
                {title}
            </Typography>
            <Typography
                variant='body2'
                component='p'
                color={dark ? 'whiteMediumEmphasis' : 'blackMediumEmphasis'}
                className={`!mb-0 mt-2 leading-7 ${dark ? 'text-white/70' : ''}`}>
                {subtitle}
            </Typography>
            {dark && (
                <Link
                    href={href}
                    prefetch={false}
                    className='mt-5 inline-flex min-h-11 items-center gap-2 rounded-xl bg-brandYellow px-5 text-sm font-extrabold text-slate-950
                        no-underline transition-colors hover:bg-amber-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4
                        focus-visible:outline-white motion-reduce:transition-none'>
                    {linkLabel}
                    <ArrowLeft size={18} color='currentColor' aria-hidden className='shrink-0' />
                </Link>
            )}
        </div>
        {!dark && (
            <Link
                href={href}
                prefetch={false}
                className='inline-flex min-h-11 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-xl px-3 text-sm font-bold text-secondary
                    no-underline transition-colors hover:bg-primary/5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                    focus-visible:outline-secondary motion-reduce:transition-none'>
                {linkLabel}
                <ArrowLeft size={16} color='currentColor' aria-hidden className='shrink-0' />
            </Link>
        )}
    </div>
);
